let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("evQM7")).then(() => parcelRequire('dnyce'));